import { call, put, select } from "redux-saga/effects";
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";
import { selectNotificationState } from "../../../state/notification/notificationSlice";
import { saveNotifications } from "../../../browser/storage";

export function* saveNotificationsSaga() {
  try {
    const { uid } = yield select(selectUserCredentials);
    if (!uid) return;

    const { list, enabled } = yield select(selectNotificationState);

    yield call(saveNotifications, {
      uid,
      data: { list, enabled },
    });

  } catch (err) {
    console.error("Failed to save notifications:", err);
  }
}